<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      width="500px"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => $refs.main.cancel()"
      append-to-body
      v-el-dialog-drag
    >
      <Main
        ref="main"
        :custCode="custCode"
        :custBrandCode="custBrandCode"
        @close="close"
        @reload="$emit('reload')"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="$refs.main.save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    type: { type: String, default: '' },
    custCode: { type: String, default: '' },
    custBrandCode: { type: String, default: '' },
  },
  computed: {
    titleMap() {
      return {
        add: this.$l('dialog_title_addBrand') || '新增客户品牌',
        edit: this.$l('dialog_title_editBrand') || '编辑客户品牌',
      }
    },
    title() {
      return this.titleMap[this.type]
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
